import SearchBox from "../../../common_nextgen/common_components/SearchScreenComponents/SearchBox";

import DisplayTable from "../../../common_nextgen/common_components/SearchScreenComponents/DisplayTable";
import ButtonsSection from "../../../common_nextgen/common_components/SearchScreenComponents/ButtonsSection";
import NextGenPaginator from "../../../common_nextgen/common_components/Pagination/NextGenPaginator";
import ConfirmationModal from "../../../common_nextgen/common_components/Modal/ConfirmationModal";
import useThirdPartyException from "./hooks/useThirdPartyException";

const ThirdPartyException = ({
  onSelect,
  hideModal,
  params,
  lookupType,
  selectModeParamData,
}) => {
  const thirdPartyExceptionData = useThirdPartyException(
    onSelect,
    hideModal,
    params,
    lookupType,
    selectModeParamData
  );

  return (
    <div class="container container-fluid">
      <ButtonsSection
        ctaButtons={thirdPartyExceptionData.leftButtons}
        align="left"
      />
      <div className="header-section">
        <h1>
          {thirdPartyExceptionData.screen_title} -{" "}
          <span className="heading-cod">
            {thirdPartyExceptionData.screenNumber}
          </span>
        </h1>
      </div>
      <SearchBox
        formFields={thirdPartyExceptionData.formFields}
        dropdownValues={thirdPartyExceptionData.dropdownValues}
        paramsData={thirdPartyExceptionData.paramsData}
        updataParamData={thirdPartyExceptionData.updateParamData}
      />
      <ButtonsSection ctaButtons={thirdPartyExceptionData.ctaButtons} />
      <DisplayTable
        data={thirdPartyExceptionData.data}
        parmKey={thirdPartyExceptionData.parmKey}
        menuOptions={thirdPartyExceptionData.menuOptions}
        tableHeaders={thirdPartyExceptionData.columnDef}
        setRowData={thirdPartyExceptionData.setRowData}
        selectedPriceSchedules={thirdPartyExceptionData.selectedRows}
        setSelectedPriceSchedules={thirdPartyExceptionData.setSelectedRows}
        selectMode={true}
      />
      <div className="paginator-container">
        <NextGenPaginator
          first={thirdPartyExceptionData.first}
          rows={thirdPartyExceptionData.rows}
          totalRecords={thirdPartyExceptionData.totalRecords}
          currentPage={thirdPartyExceptionData.currentPage}
          rowsPerPageOptions={[10, 25, 50]}
          onPageChange={thirdPartyExceptionData.onPageChange}
        />
      </div>
      {thirdPartyExceptionData.isConfirmationModalOpen && (
        <ConfirmationModal
          isOpen={thirdPartyExceptionData.isConfirmationModalOpen}
          onRequestClose={thirdPartyExceptionData.closeConfirmationModal}
          onBack={thirdPartyExceptionData.closeConfirmationModal}
          onSave={thirdPartyExceptionData.deletePriceSchedule}
          confirmLabel="Confirm(Y/N)"
          options={[
            { label: "N-No", value: "no" },
            { label: "Y-Yes", value: "yes" },
          ]}
          setSelectedOption={thirdPartyExceptionData.setSelectedOption}
        />
      )}
      {thirdPartyExceptionData.isHideConfirmationModalOpen && (
        <ConfirmationModal
          isOpen={thirdPartyExceptionData.isHideConfirmationModalOpen}
          onRequestClose={thirdPartyExceptionData.closeHideConfirmationModal}
          onBack={thirdPartyExceptionData.closeHideConfirmationModal}
          onSave={thirdPartyExceptionData.hidePriceSchedule}
          confirmLabel="Confirm(Y/N)"
          options={[
            { label: "N-No", value: "no" },
            { label: "Y-Yes", value: "yes" },
          ]}
          setSelectedOption={thirdPartyExceptionData.setHideSelectedOption}
        />
      )}
    </div>
  );
};

export default ThirdPartyException;
